import React, { useEffect, useState, useContext, useRef, Children } from 'react';
import { Popconfirm, Button, Popover, Modal, Col, ConfigProvider, DatePicker, Form, Input, InputNumber, Table, Row, Select, Switch, TreeSelect, QRCode, Typography, Tree, Tooltip } from 'antd';
import Icon, { SearchOutlined, PlusOutlined, ExclamationCircleOutlined, DeleteOutlined, EllipsisOutlined, PropertySafetyFilled, ControlOutlined, ToolOutlined } from '@ant-design/icons';
import { ProTable, TableDropdown } from '@ant-design/pro-components';
import axios from 'axios';
import styled from 'styled-components';
import Label_language from '../../language';
import ImportButton from './ImportButton';
import 'antd/dist/reset.css';
const Contaner = styled.div`
    .ant-pro-table-list-toolbar-setting-items{
        display:flex;
        justify-content:right;
        column-gap: 10px;
        margin:5px;
    }
    .ant-pro-table-list-toolbar-search{
        padding:5px;
    }
`

const { RangePicker } = DatePicker;
const label_language = Label_language.ems.children;

const NewTable = ({
    force_reset,
    ...props
}) => {
    const [pageSize, setPageSize] = useState({
        current: 1,
        pageSize: 10,
    });
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [custom_column, set_custom_column] = useState(null);
    const [sort, set_sort] = useState(null);
    const [filter, set_filter] = useState(null);
    const ref = useRef(0);
    const { confirm } = Modal;
    const actionRef = useRef();
    const [checklist, setChecklist] = useState([])
    const [search, set_search] = useState('');
    const [filter_column, set_filter_column] = useState();
    const handleOnEncode = (value) => {
        var tmp = "";
        for (var i = 0; i < value.length; i++) {
            if (value.charCodeAt(i) == 12288) {
                tmp += String.fromCharCode(value.charCodeAt(i) - 12256);
                continue;
            }
            if (value.charCodeAt(i) > 65280 && value.charCodeAt(i) < 65375) {
                tmp += String.fromCharCode(value.charCodeAt(i) - 65248);
            }
            else {
                tmp += String.fromCharCode(value.charCodeAt(i));
            }
        }
        return tmp;
    }
    useEffect(() => {
        actionRef.current.reload()
        // actionRef.current.reloadAndRest();
    }, [props.force_reload])
    const rowSelection = {
        selectedRowKeys: props.selectedRowKeys,
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (props.selectedRowKeys.length !== 0) {
                props.setSelectedRowKeys([]);
            }
        },
        onChange: (selectedRowKeys, selectedRows) => {
            props.setSelectedRowKeys(selectedRowKeys);

        },

    };
    const showMessageAll = () => {
        confirm({
            title: label_language.Common.children.sure_delete[language],
            icon: <ExclamationCircleOutlined />,
            okText: label_language.Common.children.sure[language],
            okType: 'primary',
            cancelText: label_language.Common.children.cancel[language],
            onOk() {
                props.handleOnDeleteRow();
            },
            centered: true
        });
    };
    useEffect(() => {
        if (custom_column !== null) {
            axios
                .post('/cramSchool/api/custom_page_setting', [{
                    page_name: props.page_name,
                    custom_setting: custom_column
                }])
        } else {
            axios
                .get('/cramSchool/api/custom_page_setting', {
                    params: {
                        page_name: props.page_name,
                    }
                })
                .then(response => {
                    let custom_column_temp = {};
                    response.data.forEach(each_item => {
                        custom_column_temp = each_item?.custom_setting
                    })
                    set_custom_column(custom_column_temp)
                })
        }
    }, [custom_column])
    useEffect(() => {
        if (custom_column !== null) {
            let data_tmp = Object.entries(custom_column);
            let custom_column_tmp = [];
            data_tmp && data_tmp.map((item, i) => {
                if (item[1].show == true) {
                    // console.log(item?.[0]?.split('-')?.[item[0]?.split('-')?.length-1])
                    custom_column_tmp.push(item?.[0]?.split('-')?.[item[0]?.split('-')?.length - 1]);
                }
            })
            if (props.set_language_time != undefined) {
                props.set_language_time(custom_column_tmp);
            }
            // console.log(props.set_language_time);
            // console.log(custom_column_tmp)
        }

    }, [custom_column])
    const changeData = (record) => {
        // console.log(record);
        // console.log(props.importData);
        let data_tmp = props.importData.filter(item => item.index != record.index);
        // console.log(data_tmp);
        props.setImportData(data_tmp);
    }
    const handleTableChange = (params) => {
        // console.log(params);
        setPageSize(params);
    };
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [force_reset])
    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Contaner>
                        <ProTable
                            actionRef={actionRef}
                            tableLayout={'fixed'}
                            scroll={{ x: 'max-content' }}
                            request={async (param, sort, filter) => {
                                set_sort(sort)
                                set_filter(filter)
                                // console.log(param);
                                if (param?.keyword) {
                                    let params = handleOnEncode(param?.keyword)
                                    param = { ...param, keyword: params };
                                }
                                // let params = {
                                //     cur_page: param.current,
                                //     size: param.pageSize
                                // }
                                return props.getData(param, sort, filter, checklist.filter(map_item => map_item)
                                    .map(map_item => {
                                        // console.log(typeof map_item)
                                        if (typeof map_item === 'object') {
                                            let map_item_tmp = '';
                                            Object.entries(map_item).forEach(([each_key, each_item]) => {
                                                map_item_tmp = each_item
                                            });
                                            return map_item_tmp
                                        } else {
                                            return map_item
                                        }
                                    })
                                )
                            }}
                            tableAlertRender={false}
                            dataSource={props.datas}
                            loading={props.loading}
                            editable={{
                                type: 'multiple',
                            }}
                            columnsState={{
                                value: custom_column,
                                onChange(value) {
                                    set_custom_column(value)
                                    //製作排序及拖移
                                    // console.log(value);
                                },
                            }}
                            rowKey={props.rowkey}
                            search={false}
                            options={{


                                search: {

                                    onChange: (e) => set_search(e.target.value),
                                    value: search,
                                    suffix: (<>
                                        {/* <CloseCircleOutlined style={{ cursor: 'pointer' }} onClick={clear} /> */}
                                        <FilterSearchColumns
                                            columns={props.columns}
                                            checklist={checklist}
                                            setChecklist={setChecklist}
                                        />
                                    </>),
                                    allowClear: true,
                                    enterButton: <>
                                        <SearchOutlined style={{ display: "inline-flex", alignItems: "center" }} /></>,
                                },
                                // draggable: true,
                                // checkable: true,
                                // checkedReset: false,
                                setting: {
                                    listsHeight: 400,
                                    extra: [
                                        <>
                                            <Manage_columns columns={props.columns} selected={props.extra_columns} set_selected={(e) => {
                                                props.set_extra_columns(e.map(map_item => {
                                                    return {
                                                        title: map_item,
                                                        dataIndex: map_item,
                                                        key: map_item,
                                                    }
                                                }))
                                            }} />
                                        </>
                                    ],
                                },
                            }}
                            // form={{
                            //     syncToUrl: (values, type) => {
                            //         console.log(123);
                            //         console.log(values);
                            //         if (type === 'get') {
                            //             return {
                            //                 ...values,
                            //                 created_at: [values.startTime, values.endTime],
                            //             };
                            //         }
                            //         return values;
                            //     },
                            // }}
                            pagination={{
                                ...pageSize,
                                total: props.total,
                                //設定頁數
                                // onChange: (page) => setPageSize(page),
                            }}
                            // pagination={pageSize}
                            onChange={handleTableChange}
                            dateFormatter="string"
                            // headerTitle="高级表格"
                            toolBarRender={() => [
                                // ...props.toolBarRender,
                                <>
                                    <Row gutter={[4, 8]} align={'middle'}>
                                        {/* <Space wrap > */}
                                        {
                                            props.QRcodePunch && (<Col>
                                                <Button
                                                    type="primary"
                                                    onClick={e => {
                                                        props.handleQRcodePunch()
                                                    }}>
                                                    今日簽到打卡
                                                </Button>

                                            </Col>)
                                        }
                                        {(props.handleSearchDate || props.searchdate) && (<>
                                            <Col>
                                                <label style={{ fontSize: '16px', color: '#505050', fontWeight: 700 }}>{props.rangepicker_title}： </label>
                                            </Col>
                                            <Col>
                                                <RangePicker
                                                    // defaultValue={[moment(), moment()]}
                                                    format={'YYYY-MM-DD'}
                                                    // style={{ textAlign: 'center', width: window.innerWidth > 500 ? 300 : '100%' }}
                                                    onChange={(date, dateString) => props.handleSearchDate(dateString)}
                                                />
                                            </Col>
                                        </>)}
                                        {(props.searchYear) && (<>
                                            <Col>
                                                <label style={{ fontSize: '16px', color: '#505050', fontWeight: 700 }}>{"年份"}： </label>
                                            </Col>
                                            <Col>
                                                <DatePicker.YearPicker
                                                    // defaultValue={[moment(), moment()]}
                                                    format={'YYYY'}
                                                    // style={{ textAlign: 'center', width: window.innerWidth > 500 ? 300 : '100%' }}
                                                    onChange={(date, dateString) => props.handleSearchYear(dateString)}
                                                />
                                            </Col>
                                        </>)}
                                        {/* <label style={{ fontSize: '16px', color: '#505050', fontWeight: 700 }}>搜尋：</label> */}
                                        {/* <Input placeholder={props.search_placeholder} style={{ width: 240 }} onChange={e => set_search(e.target.value)} /> */}
                                        {/* <Button className='example' style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} onClick={e => props.handleSearchData(search)}>搜尋</Button> */}
                                        {props.other == true ? <Col><Button className='example' onClick={e => props.handleOnAddRow()} style={{ background: '#D1E6ED', display: "inline-flex", alignItems: "center" }} >{props.other_button_title}</Button></Col> : null}
                                        {props.add != false ? <Col><Button className='example' onClick={e => props.handleOnAddRow()} icon={<PlusOutlined />} style={{ background: '#FdF9C9', display: "inline-flex", alignItems: "center" }} >{props.add_button_title}</Button></Col> : null}
                                        {props.delete != false ? <Col>
                                            <Button className='example' style={{ backgroundColor: 'rgba(255, 242, 237, 1)' }} onClick={e => showMessageAll()}>
                                                <Row>
                                                    <Col span={6}>
                                                        <img width="80%" src='/cram_school/error.png'></img>
                                                    </Col>
                                                    <Col span={18}>
                                                        <span>{label_language.Common.children.multiple_delete[language]}</span>
                                                    </Col>
                                                </Row>
                                            </Button>
                                        </Col> : null}
                                        {props.export != true ? null : <Col><Button className='example' style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} onClick={e => props.handleExport()}>{label_language.Common.children.export[language]}</Button></Col>}
                                        {/* {props.import != true ? null : <Col><Button type='file' className='example' style={{ backgroundColor: '#41A084', color: '#FFFFFF' }} onClick={(e) => props.handleImportModal()}>匯入資料</Button></Col>} */}
                                        {props.import != true ? null : <Col><ImportButton
                                            loading={props.wait_loading}
                                            handleDownload={e => props.handleDownload()}
                                            handleImport={e => props.handleImport(e)}
                                            set_upload_modal={props.set_upload_modal}
                                            upload_modal={props.upload_modal}
                                            importData={props.importData}
                                            setImportData={props.setImportData}
                                            import_modal={props.import_modal}
                                            set_import_modal={props.set_import_modal}
                                            handleReserve={e => props.handleReserve(e)}
                                            handleOver={e => props.handleOver(e)}
                                            columns={[...props.columns, {
                                                title: '保留/覆蓋',
                                                align: 'center',
                                                render: (text, record, index) => {
                                                    if (record.type == 'name') {
                                                        return (
                                                            <>
                                                                <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { props.handleReserve([record]); changeData(record) }}>保留</Button>
                                                            </>)
                                                    } else if (record.type == 'both') {
                                                        return (
                                                            <>
                                                                <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { props.handleOver([record]); changeData(record) }}>覆蓋</Button>
                                                            </>
                                                        )
                                                    }
                                                }
                                            }]}
                                        />
                                        </Col>}
                                        {
                                            props.qrcodeNotifyPdf && (<Col>
                                                <Button type="text"
                                                    style={{ background: '#c1ff72' }}
                                                    onClick={e => {
                                                        props.handleQRcodeNotifyPdf()
                                                    }}
                                                    loading={props.qrcodeNotifyLoading}
                                                    >
                                                    匯出學生通知綁定
                                                </Button>

                                            </Col>)
                                        }
                                       
                                        {/* <input type="file" id="my_file" hidden ref={ref} onChange={(e) => props.handleImport(e) }/> */}
                                        {/* </Space> */}
                                    </Row>
                                </>
                            ]}
                            {...({ ...props, columns: props.columns.map(map_item => ({ sorter: true, ...map_item })) })}
                            rowSelection={{
                                selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
                                columnWidth: '60px',
                                ...rowSelection,
                            }}
                        />
                    </Contaner>
                </Col>
            </Row >
        </>
    );
};
const FilterSearchColumns = ({ columns, checklist, setChecklist }) => {
    // console.log(columns)
    const onCheck = (list) => {
        setChecklist(list);
    }
    useEffect(() => {
        setChecklist((pre) => {
            return columns.map((value, key) => {
                if (!value.disabled) {
                    return value.key
                }
            })
        })
    }, [])
    return (<>
        <Popover
            placement="top"
            title={"選擇搜尋項目"}
            content={
                <Row>
                    <Col>
                        <Tree
                            checkable
                            onCheck={onCheck}
                            checkedKeys={checklist}
                            treeData={columns}
                        />
                    </Col>
                </Row>
            }
            trigger="click">
            <ControlOutlined />
        </Popover>
    </>
    )
}
export default NewTable;

const Manage_columns = (props) => {
    const [show, set_show] = useState(false);
    return (<>
        <Tooltip
            title={'點擊展開'}
        >
            <Button type='link' icon={<ToolOutlined style={{ verticalAlign: 'middle' }} />}
                onClick={() => set_show(prev => !prev)}
            >管理欄位</Button>
        </Tooltip>
        <Select
            hidden={!(show)}
            mode="tags"
            // options={[
            //     {
            //         value: '123',
            //         label: '123'
            //     }
            // ]}
            dropdownStyle={{ minWidth: "200px" }}
            placement={'bottomRight'}
            value={props.selected}
            onChange={(e) => {
                props.set_selected(e)
            }}
            allowClear
            maxTagCount={5}
        />
    </>)
}